/**
 * Return a unique string to use how component key into react
 */
export default function randomKey(): { readonly key: string } {
    return {
        key: '_' + Math.random().toString(36).substring(2, 9),
    }
}
